import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReferrerPortalService {
  constructor(
    private http: HttpClient
  ) { }

  getReferrerInfo(referrerId: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}`)
  }

  getReferrerals(referrerId: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals`)
  }
  
  getReferreralNotes(referrerId: string, referreralId: string, noteType: string, referralType: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals/${referralType}/${referreralId}/notes/${noteType}`)
  }  

  getReferreralReports(referrerId: string, referreralId: string, referralType: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals/${referralType}/${referreralId}/reports`)
  }
  
  getReferreralPrescriptions(referrerId: string, referreralId: string, referralType: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals/${referralType}/${referreralId}/prescriptions`)
  }
    
  getReferreralImages(referrerId: string, referreralId: string, referralType: string): Observable<any> {
    return this.http.get<any>(`/api/referrer/${referrerId}/referrals/${referralType}/${referreralId}/images`)
  }
}

